export const resonance = {
  resonance_title: 'Resonance App',
  resonance_open_app_on_mobile: 'Open the app on mobile',
  resonance_open_app_on_mobile_description: 'For a better experience, we recommend you to use the mobile app.',
  resonance_open_app_on_mobile_button: 'Open the app on mobile',
};
